import WizardNav from './component.jsx'
export default WizardNav
